<mat-paginator *ngIf="total !== 0 && !hidePaging" [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons [length]="total" (page)="getNext($event)"
  aria-label="Select page of periodic elements">
</mat-paginator>